import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Button, Flex } from "@chakra-ui/react";
import React from "react";
import Fixed from "../../components/layout/Fixed";

const FormButtons: React.FC<{
  onBackClick: () => void;
  onNextClick?: () => void;
  backText?: string;
  nextText?: string;
  isNextDisabled?: boolean;
  hideBackButton?: boolean;
  hideNextButton?: boolean;
  buttonSize?: string;
  isLoading?: boolean;
  loadingText?: string;
  width?: Array<string>;
}> = ({
  onBackClick,
  onNextClick,
  backText = "Back",
  nextText = "Next",
  isNextDisabled,
  hideBackButton,
  hideNextButton,
  buttonSize = "lg",
  isLoading = false,
  loadingText = "Submitting",
  width = ["100%", "84%", "70%", "70%", "70%"],
}) => {
  return (
    <Fixed
      mx={[-5, 0]}
      mt={[3, 0]}
      py={[4, 5, 4]}
      px={[5, 0]}
      width={width}
      bottom="0%"
      borderTopWidth="2xs"
      borderColor="gray.200"
      bg="white"
    >
      <Flex justify="space-between" align="center">
        {hideBackButton ? (
          <Box />
        ) : (
          <Button
            variant="link"
            leftIcon={<ChevronLeftIcon />}
            onClick={onBackClick}
          >
            {backText}
          </Button>
        )}

        {!hideNextButton && (
          <Box ml={["none", "auto"]} width={[9 / 20, 2 / 5]}>
            <Button
              // type="submit"
              isDisabled={isNextDisabled}
              isLoading={isLoading}
              loadingText={loadingText}
              size={buttonSize}
              rightIcon={<ChevronRightIcon />}
              isFullWidth
              colorScheme="teal"
              onClick={onNextClick}
              px={8}
            >
              {nextText}
            </Button>
          </Box>
        )}
      </Flex>
    </Fixed>
  );
};

export default FormButtons;

export const SingleFormButton: React.FC<{
  onNextClick?: () => void;
  nextText?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  [key: string]: any;
}> = ({
  onNextClick,
  nextText = "Next",
  isDisabled,
  isLoading = false,
  loadingText = "Saving",
  ...rest
}) => {
  return (
    <Flex>
      <Button
        type="submit"
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
        size="lg"
        isFullWidth
        colorScheme="blue"
        onClick={onNextClick}
      >
        {nextText}
      </Button>
    </Flex>
  );
};
